import { render, staticRenderFns } from "./PanelChat.vue?vue&type=template&id=5cf6b0ed&scoped=true&"
import script from "./PanelChat.vue?vue&type=script&lang=js&"
export * from "./PanelChat.vue?vue&type=script&lang=js&"
import style0 from "./PanelChat.vue?vue&type=style&index=0&id=5cf6b0ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6b0ed",
  null
  
)

export default component.exports